import {Geolocation} from '@capacitor/geolocation';

export const fetchLocation = () => Geolocation.getCurrentPosition({enableHighAccuracy: true});
